import { FieldConfigurationType } from "../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ReportField } from "../../../../../../../api/types/svTypes.ts";
import { ItemDataType } from "../../../../../../../api/types/svTypes.ts";
import { isCountRelatedAggregation } from "../../../utilities/aggregationHelper.ts";

export const isNumericField = (field: ReportField) => {
  return (
    field.meta.type === ItemDataType.Numeric ||
    (field.config.type === FieldConfigurationType.Aggregation && isCountRelatedAggregation(field.config.aggregation))
  );
};
